import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom'

//Components
import { Grid } from "@mui/material";
import { Modal, ModalBody, ModalFooter, Button, Select, Form, ProgressBar } from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import { NotificationManager } from 'Components/Notifications';
import { copyToClipboard } from "Core/data/Helpers"
//Actions
import {
    changeTimezoneSetDevices,
    changeTimezoneUpdateRequest,
    searchEntityRequest,
    clearRedux,
} from 'Redux/actions';

const ChangeTimezone = (props) => {
    const { tableRef, single, getDevice } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const formRef = useRef(null);
    const navigate = useNavigate()

    //Redux states
    const { loading, openModal, result, devices } = useSelector(state => state.changeTimezoneRedux);
    const timeZones = useSelector(state => state.generalRedux.timeZones);
    const timeZonesLoading = useSelector(state => state.generalRedux.timeZonesLoading);

    //local states
    const [step, setStep] = useState(1);
    const [timezone, setTimezone] = useState(null);
    
    const closeModal = () => {
        dispatch(dispatch(clearRedux("CHANGE_TIMEZONE")));
    }

    const applyChanges = () => {
        let unitIds = devices.map((item) => (item.id))
        let payload = {
            unitIds: unitIds,
            timezoneId: timezone,
            features: {}
        }
        dispatch(changeTimezoneUpdateRequest(payload));
    }

    useEffect(() => {
        if (result) {
            if (result?.update) {
                setStep(1);
                setTimezone(null);
                closeModal();
                // Show success notification with transaction details
                let transactionId = result?.update?.transactionId;
                let message = messages["change_timezpne_transaction_message"]
                NotificationManager.success(message, messages['change_timezone_title'], 10000, () => {
                    copyToClipboard(transactionId, messages['common_copied']);
                    navigate(`/app/transactions/list/${transactionId}`);

                }, null, '', null);

                tableRef && tableRef?.current?.getData();
                getDevice && getDevice();
            } else {
                NotificationManager.error(
                    messages['change_timezone_it_was_possible_to_change_the_timezone'],
                    messages['change_timezone_title'],
                    3000
                );
            }
            dispatch(dispatch(clearRedux("CHANGE_TIMEZONE", { result: null })));
        }
    }, [result])


    useEffect(() => {
        if (openModal && single) setStep(2)
    }, [openModal])

    useEffect(() => {
        timeZones && timeZones.length === 0 && dispatch(searchEntityRequest({ key: "timezones" }));
    }, []);

    return (
        <Modal
            open={openModal}
            title={messages['change_timezone_title']}
            handleClose={() => closeModal()}
            position="right"
            size="small"
            loading={loading}
        >
            <ModalBody>
                <ProgressBar steps={3} activeStep={step} />
                {
                    step === 1 &&
                    <div style={{ padding: '0 10px', marginBottom: 30 }}>
                        {
                            devices.map((item, index) => {
                                return (
                                    <CustomCard
                                        key={index}
                                        onClick={() => {
                                            let currentDevices = devices;
                                            let selected = currentDevices.findIndex((device) => device.id === item.id);
                                            if (selected > -1) currentDevices.splice(selected, 1);
                                            if (currentDevices.length === 0) closeModal();
                                            dispatch(changeTimezoneSetDevices(currentDevices));
                                        }}
                                    >
                                        <div style={{ display: 'grid' }}>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['change_timezone_device_name']}</label><span>{item?.label}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>ESN</label><span>{item?.esn}</span>
                                            </div>
                                        </div>
                                    </CustomCard>
                                )
                            })
                        }
                    </div>
                }
                {
                    step === 2 &&
                    <div style={{ padding: '0 10px' }}>
                        <Form
                            ref={formRef}
                            onValidSubmit={() => applyChanges()}
                        >
                            <Grid item xs={12} style={{ marginTop: 10 }} >
                                <Select
                                    id="timezones"
                                    label={messages['feature_tab_timezone']}
                                    placeholder={messages['feature_tab_timezone']}
                                    options={timeZones || []}
                                    value={timezone ? timeZones.find(x => x.id === timezone) : null}
                                    textField="name"
                                    valueField="id"
                                    onChange={(timezone) => {
                                        setTimezone(timezone?.id || null)
                                    }}
                                    required
                                    requiredMessage={messages['required_field']}
                                />
                            </Grid>
                        </Form>
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <Button
                    className={"btn-cancel"}
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                {
                    step === 2 && !single &&
                    <Button
                        style={{ backgroundColor: '#e4e4e4' }}
                        className="btn-cancel"
                        onClick={() => {
                            setTimezone(null);
                            setStep(1);
                        }}
                    >
                        {messages['common_back']}
                    </Button>
                }
                <Button
                    className="btn-dark-blue"
                    onClick={() => step === 2 ? formRef?.current?.submit() : setStep(2)}
                >
                    {step === 2 ? messages['change_timezone_change'] : messages['common_next']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ChangeTimezone;